import { useCustomLoader } from '@/components/Loader'
import CustomDatePicker from '@/components/material/CustomDatePicker'
import CustomDrawer from '@/components/material/CustomDrawer'
import { useToast } from '@/hooks/use-toast'
import { zodResolver } from '@hookform/resolvers/zod'
import { Grid, TextField } from '@mui/material'

import dayjs from 'dayjs'
import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import { z } from 'zod'

const meetingSchema = z.object({
    title: z.string().min(1, "Title is required"),
    committee: z.string().min(1, "Committee is required"),
    startsAt: z.date(),
    endsAt: z.date(),
    agenda: z.string().min(1, "Agenda is required"),
    location: z.string().min(1, "Location is required"),
    attendees: z.array(z.string()).min(1, "At least one attendee is required").min(1, "At least one attendee is required"),
})

const MeetingAdd = ({openAdd, setOpenAdd} :any) => {
    const { toast } = useToast()
    const loader = useCustomLoader();

    const { control, handleSubmit, reset, formState: { errors } } = useForm({
        resolver: zodResolver(meetingSchema),
        defaultValues: {
            title: "",
            committee: "",
            startsAt: dayjs(),
            endsAt: dayjs(),
            agenda: "",
            location: "",
            attendees: []
        }
    })

    const onSubmit = (payload: any) => {
        loader(true);
        try {

        } catch (error) {

        }
        finally {
            loader(false);
        }
    }
    return (
        <div>
            <CustomDrawer
                handleSubmit={handleSubmit}
                title="Add Meeting"
                onSubmit={() => console.log("asdf")}
                onClose={() => setOpenAdd(false)}
            >
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 12 }}>
                        <Controller
                            control={control}
                            name="title"
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    label="Title"
                                    fullWidth
                                    error={!!errors.title}
                                    helperText={errors.title?.message}
                                    placeholder='Meeting Title'
                                />
                            )}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }}>
                        <Controller
                            control={control}
                            name="committee"
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    label="Committee"
                                    fullWidth
                                    error={!!errors.committee}
                                    helperText={errors.committee?.message}
                                    placeholder='Committee'
                                />
                            )}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 12 }}>
                        <Controller
                            control={control}
                            name="startsAt"
                            render={({ field }) => (
                                <CustomDatePicker label="Starts At" field={field} errors={errors} />
                            )}
                        />                    
                    </Grid>

                    <Grid size={{ xs: 12, sm: 12 }}>
                        <Controller
                            control={control}
                            name="endsAt"
                            render={({ field }) => (
                                <CustomDatePicker label="Ends At" field={field} errors={errors} />
                            )}
                        />                    
                    </Grid>

                    <Grid size={{ xs: 12, sm: 12 }}>
                        <Controller
                            control={control}
                            name="agenda"
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    label="Agenda"
                                    fullWidth
                                    error={!!errors.agenda}
                                    helperText={errors.agenda?.message}
                                    placeholder='Agenda'
                                />
                            )}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 12 }}>
                        <Controller
                            control={control}
                            name="location"
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    label="Location"
                                    fullWidth
                                    error={!!errors.location}
                                    helperText={errors.location?.message}
                                    placeholder='Location'
                                />
                            )}
                        />
                    </Grid>



                </Grid>
            </CustomDrawer>

        </div>
    )
}

export default MeetingAdd